import { Backdrop, CircularProgress } from "@mui/material";
import React from "react";
import { useAppSelector } from "./app/hooks";
import { selectCredentialsLoading } from "./features/credentials/credentialsSlice";

export const AppLoading = (props: any) => {
  const credentialsLoading = useAppSelector(selectCredentialsLoading);

  if (credentialsLoading || props.loading) {
    return (
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme: any) => theme.zIndex.drawer + 1,
        }}
        open={true}
      >
        <CircularProgress />
      </Backdrop>
    );
  } else {
    return props.children;
  }
};
